// src/components/Loader.tsx
import React from "react";
import { Flex, Spinner, Text } from "@chakra-ui/react";

interface LoaderProps {
  message?: string;
  color?: string;
  size?: string;
  textColor?: string;
}

const Loader: React.FC<LoaderProps> = ({
  message = "Loading...",
  color = "#B59143",
  size = "xl",
  textColor = "gray.600",
}) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      height="300px"
      width="100%"
    >
      <Spinner
        size={size}
        color={color}
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
      />
      <Text mt={3} fontSize="md" fontWeight="medium" color={textColor}>
        {message}
      </Text>
    </Flex>
  );
};

export default Loader;
